import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = process.env.REACT_APP_SITE_NAME;
export const VAPID_KEY =
  'BD7AHxoaLKaktuOF8r-2r51YwqLvtyXhcGXIThYk5ukHPhfsTE2t8gDK-D1CBuS-OaDIU5CMVQpzIfUbtcRnUpc';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const LOGO_IMAGE = `/img/logo/${process.env.REACT_APP_CLIENT_NAME}/logo.png`;
export const APP_PREFIX_PATH = "/app";
/** Max image upload size for article (and similar) image fields, in megabytes. */
export const IMAGE_MAX_UPLOAD_SIZE_MB = 3;
/** Max video upload size for video gallery and similar, in megabytes. */
export const VIDEO_MAX_UPLOAD_SIZE_MB = 65;
/** Max audio upload size for audio gallery and similar, in megabytes. */
export const AUDIO_MAX_UPLOAD_SIZE_MB = 20;
export const DEFAULT_PAGE_SIZE = 15;
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const UNAUTHENTICATED_ENTRY = "/login";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const REDIRECT_COMPONENT_KEY = "dashboard";

export const THEME_CONFIG = {
  navCollapsed: true,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
};
